import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-params"
}
const _hoisted_2 = {
  key: 0,
  class: "row flexwrap marg-s mleft-07"
}
const _hoisted_3 = { class: "bg-modal w-maxC" }
const _hoisted_4 = { class: "w-maxC" }
const _hoisted_5 = {
  key: 1,
  class: "row flexwrap marg-s mleft-07"
}
const _hoisted_6 = { class: "w-maxC" }

import { useCurrentEntryStore } from "@/stores/currentEntry";
import { useUiStore } from "@/stores/ui";
import { computed, ref } from "vue";
import gen from "@/functions/general.js";
import patientapi from "@/api/patientapi";


export default /*@__PURE__*/_defineComponent({
  __name: 'esConsultationTopbar',
  props: {
    templateDocArr: {},
    sapExprArr: {},
    bioPrescrArr: {}
  },
  setup(__props: any) {

const dropd = ref(null)
const props = __props;

const uiStore = useUiStore();
const currentEntryStore = useCurrentEntryStore();

const sortedSapExprArr = computed(() => {
  let ret = gen.deepCopy(props.sapExprArr)
  return ret.sort((a, b) => b.order > a.order);
});


function medicAction(expr) {
  uiStore.setCclTextSelection("");
  currentEntryStore.clearCurrExpr_Ccl();
  currentEntryStore.setCurrSuggestionsForDashboard(null);
  currentEntryStore.setPoppedSapExpr(expr);
  uiStore.setDashBoardItem(expr);
}

async function patientDocAction(documentExpr) {
  currentEntryStore.setMiddleTab('docTemplate');
  //Reload
  currentEntryStore.emptyCurrentDoc();
  currentEntryStore.clearCurrExpr_Ccl();
  const fullPatientDoc = await patientapi.getPatientDocument(documentExpr.patientDocumentId, currentEntryStore.currentEntryId);
  currentEntryStore.setCurrentDoc(fullPatientDoc);
}


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (props.bioPrescrArr.length || sortedSapExprArr.value.length || _ctx.templateDocArr.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.bioPrescrArr.length || sortedSapExprArr.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (props.bioPrescrArr.length > 0)
                ? (_openBlock(), _createBlock(_component_dropdownBox, {
                    key: 0,
                    modelValue: dropd.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
                    openOn: "Bio",
                    class: "params-row mleft-02 mbottom-02"
                  }, {
                    dropd: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_dbGroup, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bioPrescrArr, (item, index) => {
                              return (_openBlock(), _createBlock(_component_text_item, {
                                key: index,
                                txt: item.originalText,
                                class: "bio-text-max-w"
                              }, null, 8, ["txt"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, {
                        styles: "pad-s",
                        maxWidth: true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_item, {
                            icon: "beaker",
                            class: "item-center",
                            size: '12px'
                          }),
                          _createVNode(_component_text_item, {
                            txt: props.bioPrescrArr.length.toString(),
                            class: "mleft-01"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSapExprArr.value, (sapExpr, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "params-row mleft-02 mbottom-02"
                }, [
                  _createVNode(_component_buttonGroup, {
                    styles: "pad-s",
                    maxWidth: true,
                    onClick: _withModifiers(($event: any) => (medicAction(sapExpr)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_svg_item, {
                          icon: sapExpr.icon,
                          class: "item-center square-12"
                        }, null, 8, ["icon"])
                      ]),
                      _createVNode(_component_text_item, {
                        txt: sapExpr.text,
                        class: "mleft-01"
                      }, null, 8, ["txt"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.templateDocArr.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateDocArr, (templateDoc, index2) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index2,
                  class: "params-row mleft-02 mbottom-02"
                }, [
                  _createVNode(_component_buttonGroup, {
                    styles: "pad-s",
                    maxWidth: true,
                    onClick: _withModifiers(($event: any) => (patientDocAction(templateDoc.documentExpression)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_svg_item, {
                          icon: templateDoc.icon,
                          class: "item-center square-12"
                        }, null, 8, ["icon"])
                      ]),
                      _createVNode(_component_text_item, {
                        txt: templateDoc.text,
                        class: "mleft-01"
                      }, null, 8, ["txt"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})